import React from "react";

const SunIcon = (props: any) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.99 5.626a6.376 6.376 0 1 0 6.376 6.376 6.383 6.383 0 0 0-6.375-6.376ZM22.126 10.877h-1.499a1.125 1.125 0 1 0 0 2.25h1.499a1.125 1.125 0 1 0 0-2.25ZM11.99 19.5a1.127 1.127 0 0 0-1.124 1.125v1.5a1.124 1.124 0 0 0 2.249 0v-1.5A1.126 1.126 0 0 0 11.99 19.5ZM4.497 12.002a1.126 1.126 0 0 0-1.124-1.125H1.874a1.125 1.125 0 1 0 0 2.25h1.499a1.126 1.126 0 0 0 1.124-1.125ZM11.99 4.5a1.126 1.126 0 0 0 1.125-1.125v-1.5a1.124 1.124 0 1 0-2.249 0v1.5a1.126 1.126 0 0 0 1.125 1.126ZM18.886 6.697l1.06-1.06a1.125 1.125 0 1 0-1.59-1.59l-1.06 1.06a1.125 1.125 0 1 0 1.59 1.59ZM18.886 17.307a1.125 1.125 0 1 0-1.59 1.59l1.06 1.061a1.124 1.124 0 1 0 1.59-1.59l-1.06-1.06ZM5.095 17.307l-1.06 1.061a1.124 1.124 0 1 0 1.59 1.59l1.06-1.06a1.126 1.126 0 0 0-.363-1.836 1.125 1.125 0 0 0-1.227.245ZM5.095 6.697a1.124 1.124 0 1 0 1.59-1.59l-1.06-1.06a1.124 1.124 0 1 0-1.59 1.59l1.06 1.06Z"
      fill="#3D68FF"
    />
  </svg>
);

export default SunIcon;
